<template lang="jade">
  a(v-if="template.media === 'print'" 
    target="_blank" 
    ":href"="downloadURL") {{ dataset.title}}
  a(v-else @click.prevent="openAs") {{ dataset.title }}
</template>

<script>
import { forms } from 'src/vuex/getters'
import { addDynamicWorkflow } from 'src/vuex/actions'
// import { Data } from 'src/services/resources'
import api from 'src/config/api'

export default {
  data () {
    return { uid: this.$parent.uid }
  },
  props: {
    dataset: {
      type: Object,
      required: true
    },
    template: {
      type: Object,
      required: true
    }
  },
  computed: {
    form () {
      return _.find(this.forms, ['uid', this.uid])
    },

    WFO () {
      let wf = this.dataset
      return { wid: wf.workflowId,
               sid: this.form.siteid,
               readonly: true,
               params: { workflowParameters: wf.workflowParameters,
                         dbWorkflowKey: wf.dbWorkflowKey } }
    },
    downloadURL () {
      let data = _.assign({siteId: 'Member'}, this.template, this.dataset)
      let params = _.pick(data, ['siteId', 'workflowId', 'dbWorkflowKey', 'workflowParameters', 'actions', 'openAs'])
      let render = _.template('<%= origin %><%= pathname %>?<%= params %>')
      let url = render({origin: api.http.root,
                        pathname: api.endpoints.data.pdf,
                        params: this.queryString(params) })
      return encodeURI(url)
    }
  },
  vuex: {
    getters: {
      forms
    },
    actions: {
      addDynamicWorkflow
    }
  },
  methods: {
    openAs () {
      this.dialog()
    },

    dialog () {
      this.addDynamicWorkflow(this.WFO)
    },

    tab () {
      /* eslint-disable no-undef */
      localStorage.setItem('tab::workflow',
                           JSON.stringify(this.WFO))
      window.open(window.location.href, '_blank')
    },

    queryString (params) {
      return Object.entries(params)
                   .map(this.paramString)
                   .join('&')
    },

    paramString (pair) {
      let [k, v] = pair
      switch (Object.prototype.toString.call(v)) {
        case '[object Object]':
          return this.objParamString(k, v)
        case '[object Array]':
          return `${k}[]=${v[0]}`
        default:
          return `${k}=${v}`
      }
    },

    objParamString (prop, params) {
      return Object.entries(params).map(xs => `${prop}[${xs[0]}]=${xs[1]}`).join('&')
    }
  }
}
</script>



// WEBPACK FOOTER //
// widget.vue?db42cae2